/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S9_Li1Inputs */

const tr_mesafeli_s9_li1 = /** @type {(inputs: Mesafeli_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI çıktıları olasılıksal niteliktedir; nihai karar Müşteri'nindir. Sağlayıcı, kastı ve ağır kusuru ile tüketicilerin emredici haklarından doğan sorumluluğu saklı kalmak üzere, AI çıktısının doğruluğundan, ticari uygunluğundan veya neden olabileceği zararlardan sorumlu değildir.`)
};

const en_mesafeli_s9_li1 = /** @type {(inputs: Mesafeli_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI outputs are probabilistic in nature; the final decision rests with the Customer. Subject to its liability for intent and gross negligence and to mandatory consumer rights, the Provider is not liable for the accuracy or commercial suitability of AI output or for any damage it may cause.`)
};

const de_mesafeli_s9_li1 = /** @type {(inputs: Mesafeli_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Ausgaben sind probabilistischer Natur; die endgültige Entscheidung liegt beim Kunden. Vorbehaltlich seiner Haftung für Vorsatz und grobe Fahrlässigkeit sowie der zwingenden Verbraucherrechte haftet der Anbieter nicht für die Richtigkeit, die kommerzielle Eignung oder etwaige Schäden aus KI-Ausgaben.`)
};

const ru_mesafeli_s9_li1 = /** @type {(inputs: Mesafeli_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты работы ИИ носят вероятностный характер; окончательное решение принимает Клиент. С учётом ответственности за умысел и грубую неосторожность, а также императивных прав потребителей, Поставщик не несёт ответственности за точность, коммерческую пригодность результатов ИИ или возможный причинённый ими ущерб.`)
};

/**
* | output |
* | --- |
* | "AI outputs are probabilistic in nature; the final decision rests with the Customer. Subject to its liability for intent and gross negligence and to mandatory..." |
*
* @param {Mesafeli_S9_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s9_li1 = /** @type {((inputs?: Mesafeli_S9_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S9_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s9_li1(inputs)
	if (locale === "de") return de_mesafeli_s9_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s9_li1(inputs)
	return tr_mesafeli_s9_li1(inputs)
});